import {
    FETCH_RELATIONS_REQUEST,
    GET_RELATIONS,
    RELATIONS_ERROR,
    GET_SINGLE_RELATION,
    PUT_FILTERED_RELATIONS,
    GET_FILTERED_RELATIONS,
    PUT_DEACTIVATED_RELATIONS,
    PUT_REACTIVATED_RELATIONS,
    GET_SOME_RELATIONS,
    GET_SOME_PARTNER_RELATIONS,
    GET_CURRENT_OFFERINGS,
} from '../ActionTypes';

const initialState = {
    relations: [],
    singleRelation: [],
    filteredRelations: [],
    someRelations: [],
    somePartnerRelations: [],
    deactivatedRelations: [],
    loading: true,
    error: '',
    currentOfferings: [],
};

const relationReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RELATIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_RELATIONS:
            return {
                ...state,
                relations: action.payload,
                loading: false,
                error: '',
            };
        case GET_FILTERED_RELATIONS:
            return {
                ...state,
                filteredRelations: action.payload,
                loading: false,
                error: '',
            };
        case PUT_FILTERED_RELATIONS:
            return {
                ...state,
                filteredRelations: action.payload,
                loading: false,
                error: '',
            };
        case PUT_DEACTIVATED_RELATIONS:
            return {
                ...state,
                deactivatedRelations: [
                    ...state.deactivatedRelations,
                    action.payload,
                ],
                loading: false,
                error: '',
            };
        case PUT_REACTIVATED_RELATIONS:
            const reactivateIndex = state.deactivatedRelations
                .map((index) => index.id === action.payload.id)
                .indexOf(true);
            return {
                ...state,
                deactivatedRelations: state.deactivatedRelations.filter(
                    (item) =>
                        item !== state.deactivatedRelations[reactivateIndex]
                ),
                loading: false,
                error: '',
            };
        case GET_CURRENT_OFFERINGS:
            return {
                ...state,
                currentOfferings: action.payload,
            };
        case GET_SINGLE_RELATION:
            return {
                ...state,
                singleRelation: action.payload,
                loading: false,
                error: '',
            };
        case GET_SOME_RELATIONS:
            return {
                ...state,
                someRelations: action.payload,
                loading: false,
                error: '',
            };
        case RELATIONS_ERROR:
            return {
                ...state,
                relations: [],
                loading: false,
                error: action.payload,
            };
        case GET_SOME_PARTNER_RELATIONS:
            return {
                ...state,
                somePartnerRelations: action.payload,
            };
        default:
            return state;
    }
};

export default relationReduction;
